import { useMutation } from '@tanstack/react-query';
import { uploadFile } from './file.queries';

export const useUploadFile = () => {
  const mutation = useMutation({
    mutationFn: (file: File) => uploadFile(file),
  });

  return mutation;
};
